export const UsageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.4354 9.50814C12.0515 7.89175 14.6715 7.89228 16.2882 9.50814C17.7243 10.9433 17.8841 13.1701 16.77 14.7832L18.1258 16.1382L18.1771 16.1951C18.4176 16.4897 18.4005 16.9247 18.1258 17.1994C17.8511 17.474 17.4162 17.4911 17.1216 17.2507L17.0646 17.1994L15.7096 15.8436C14.0965 16.9576 11.8698 16.7987 10.4346 15.3626C8.81847 13.7458 8.81845 11.1242 10.4354 9.50814ZM15.2287 10.5693C14.2296 9.57033 12.6299 9.53943 11.5942 10.4757L11.4958 10.5693C10.4971 11.5674 10.4655 13.1673 11.4022 14.2038L11.4958 14.3022L11.5942 14.3958C12.6299 15.3321 14.2296 15.3013 15.2287 14.3022C16.2277 13.3033 16.2585 11.7034 15.3223 10.6678L15.2287 10.5693Z"
        fill="#282828"
      />
      <path
        d="M6.74316 15.1095C7.12145 15.1479 7.41699 15.4674 7.41699 15.8558C7.41697 16.2442 7.12144 16.5637 6.74316 16.6021L6.66667 16.6061H2.91667C2.50246 16.6061 2.16636 16.27 2.16634 15.8558C2.16634 15.4416 2.50245 15.1055 2.91667 15.1055H6.66667L6.74316 15.1095Z"
        fill="#282828"
      />
      <path
        d="M6.74316 9.48454C7.12145 9.52286 7.41699 9.8424 7.41699 10.2308C7.41697 10.6192 7.12144 10.9387 6.74316 10.9771L6.66667 10.9811H2.91667C2.50246 10.9811 2.16636 10.645 2.16634 10.2308C2.16634 9.81658 2.50245 9.48047 2.91667 9.48047H6.66667L6.74316 9.48454Z"
        fill="#282828"
      />
      <path
        d="M17.9932 3.85954C18.3714 3.89785 18.667 4.2174 18.667 4.60579C18.667 4.99419 18.3714 5.31373 17.9932 5.35205L17.9167 5.35612H2.91667C2.50245 5.35612 2.16634 5.02001 2.16634 4.60579C2.16634 4.19158 2.50245 3.85547 2.91667 3.85547H17.9167L17.9932 3.85954Z"
        fill="#282828"
      />
    </svg>
  );
};
